"use client"

import { useOnce } from "@/hooks/use-once"
import { useCustomSearchParams } from "@/hooks/use-search-params"
import { useLoginData } from "@/services/hooks/use-login-data"
import dynamic from "next/dynamic"

const LazyInformationDisplayDialog = dynamic(
  () => import("./information-display-dialog"),
)

export function InformationDisplay() {
  const [searchParams, setSearchParams] = useCustomSearchParams()
  const loginData = useLoginData()

  const canShowDialogs = !!loginData

  useOnce(() => {
    setSearchParams((prevParams) => {
      prevParams.delete("informationDisplay")
      return prevParams
    })
  })

  if (searchParams.get("informationDisplay") !== "open" || !canShowDialogs)
    return null

  return <LazyInformationDisplayDialog />
}
